import React, { useState } from "react";
import { MdRefresh } from "react-icons/md";


export function InfoBox({ title, dataPoints }) {
  return (
    <div className="info-box">
      <h4>{title}</h4>
      {dataPoints.map((point, index) => (
        <p key={index}>
          {point.label}: <span>{point.value}</span>
        </p>
      ))}
    </div>
  );
}

const InfoGrid = ({ headers, rows }) => (
  <table>
    <thead>
      <tr>
        {headers.map(header => <th key={header}>{header}</th>)}
      </tr>
    </thead>
    <tbody>
      {rows.map((row, index) => (
        <tr key={index}>
          {row.map((cell, cellIndex) => <td key={cellIndex}>{cell}</td>)}
        </tr>
      ))}
    </tbody>
  </table>
);



export const DataRefresh = ({ fetchLogAndConfigData, setLogAndConfigData }) => {
    const [loading, setLoading] = useState(false);

    const handleRefresh = async () => {
        if (!setLogAndConfigData) {
            console.error("❌ setLogAndConfigData is not defined!"); 
            return;
        }

        setLoading(true);
        console.log("🔄 Refreshing today's data...");

        try {
            const newData = await fetchLogAndConfigData(new Date(), true);
            console.log("✅ Data refresh complete!");

            if (newData) {
                console.log("📊 Updating state with fresh data:", newData);
                setLogAndConfigData({ ...newData });  // ✅ Ensures React detects state change
            }

        } catch (error) {
            console.error("❌ Error refreshing data:", error);
        }

        setLoading(false);
    };

    return (
        <button onClick={handleRefresh} disabled={loading}>
            {loading ? "Refreshing..." : <MdRefresh />}
        </button>
    );
};
